/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Send_Email_To_InviteInputs */

const en_send_email_to_invite = /** @type {(inputs: Send_Email_To_InviteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent an email to ${i?.email} with a link to reset your password.`)
};

const nl_send_email_to_invite = /** @type {(inputs: Send_Email_To_InviteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We hebben een e-mail gestuurd naar ${i?.email} met een link om je wachtwoord opnieuw in te stellen.`)
};

/**
* | output |
* | --- |
* | "We sent an email to {email} with a link to reset your password." |
*
* @param {Send_Email_To_InviteInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const send_email_to_invite = /** @type {((inputs: Send_Email_To_InviteInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Send_Email_To_InviteInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_send_email_to_invite(inputs)
	return en_send_email_to_invite(inputs)
});